import Img from "../../Components/Gallery/img"
function Gallery() {
    return (
        <>
            <main>
                <Img />
            </main>
        </>
    )
}

export default Gallery